/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

export const UserRole = {
  SUPERADMIN: "SUPERADMIN",
  OWNER: "OWNER",
  MEMBER: "MEMBER",
  GUEST: "GUEST",
} as const;
